export default __webpack_public_path__ + "static/media/food.b2762b4c.jpg";